// Dependencies
import React from 'react';

// Material
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
// uncomment and switch to generic spinner if desired
// import CircularProgress from '@mui/material/CircularProgress';

const LoadingIndicator = ({ message = 'Loading...' }) => (
	<>
		{/* This is generic */}
		{/* <Box sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
		}} >
			<CircularProgress />
			<Box>
				<Typography sx={{ fontWeight: 'bold' }}>
					{props?.message}
				</Typography>
			</Box>
		</Box> */}

		{/* This uses City specific branding */}
		<Box className="preload-spinner-container">
			<div className="preload-spinner"> </div>
			<Typography sx={{ fontWeight: 'bold' }}>{message}</Typography>
		</Box>
	</>
);

export { LoadingIndicator };
